import { fetchFips, fetchOrganizations } from '@/api'
import { FipCard } from '@/components/cards'
import { ErrorState, Loading, PageHead, PageShell } from '@/components/common'
import { useAsync } from '@/hooks'
import { useI18n } from '@/i18n'

export function Profiles() {
    const { t } = useI18n()
    const fips = useAsync(fetchFips, [])
    const organizations = useAsync(fetchOrganizations, [])

    if (fips.error) {
        return (
            <PageShell>
                <ErrorState error={fips.error} onRetry={fips.reload} />
            </PageShell>
        )
    }
    if (!fips.data) {
        return (
            <PageShell>
                <Loading />
            </PageShell>
        )
    }

    const communities = new Map((organizations.data ?? []).map((item) => [item.id, item]))

    return (
        <PageShell>
            <PageHead title={t('fips.title')} lead={t('fips.lead')} />

            <div className="grid grid--cards">
                {fips.data.map((fip) => (
                    <FipCard
                        key={fip.id}
                        fip={fip}
                        community={communities.get(fip.community)}
                        verifiers={communities}
                    />
                ))}
            </div>
        </PageShell>
    )
}
